import { useState, useMemo } from "react";
import { Button } from "antd";
import { LockOutlined, EditOutlined } from "@ant-design/icons";
import { useMarkAsCompleteHooks } from "src/DigitalProtocolModule/hooks";
import styles from "./index.module.scss";

interface FinalizateBarProps {
  category: "population" | "arms" | "soa" | "endpoints";
}

export function FinalizateBar({ category }: FinalizateBarProps) {
  const { doLockOrUnlock } = useMarkAsCompleteHooks();

  const [isLoading, setIsLoading] = useState(false);

  const label = useMemo(() => {
    let text = `cannot be edited.`;
    switch (category) {
      case "population":
        text = `Study Population ${text}`;
        break;
      case "arms":
        text = `Arms & Cohorts ${text}`;
        break;
      case "soa":
        text = `Schedule of Activities ${text}`;
        break;
      case "endpoints":
        text = `Endpoints ${text}`;
        break;
      default:
        break;
    }
    return text;
  }, [category]);

  const handleUnlock = async () => {
    let payload = {};
    switch (category) {
      case "population":
        payload = { study_population_finalize_flag: false };
        break;
      case "arms":
        payload = { arm_cohort_finalize_flag: false };
        break;
      case "soa":
        payload = { soa_finalize_flag: false };
        break;
      case "endpoints":
        payload = { endpoint_finalize_flag: false };
        break;
      default:
        break;
    }
    try {
      setIsLoading(true);
      const res = await doLockOrUnlock(payload, false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.barRoot}>
      <div className={styles.titleWithIcon}>
        <LockOutlined />
        <span>{label}</span>
      </div>
      <Button
        className={styles.unlockBtn}
        onClick={handleUnlock}
        loading={isLoading}
      >
        <EditOutlined />
        Unlock to edit
      </Button>
    </div>
  );
}
